<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: [String, Array],
    default: '',
  },
  auto: {
    type: Boolean,
    default: false,
  },
  contentClass: {
    type: [String, Array, Object],
    default: '',
  },
})

const options = computed(() => {
  if (props.auto) {
    return ({
      trigger: 'manual',
      show: !!props.text,
    })
  }
  return null
})
</script>

<template>
  <n-popover raw v-bind="options" :style="{ maxWidth: '270px' }" arrow-style="--n-color: var(--fillPagePrimary)">
    <template #trigger>
      <slot />
    </template>
    <div class="flex flex-col px-3 py-2 space-y-3 text-xs bg-fillPagePrimary rounded text-textPrimary" :class="contentClass">
      <slot name="content">
        <div v-if="Array.isArray(text)">
          <div v-for="item in text" :key="item">
            {{ item }}
          </div>
        </div>
        <span v-else>{{ text }}</span>
      </slot>
    </div>
  </n-popover>
</template>
